export const hasVelocifi = () => {
  return window?.location?.hostname.includes('velocifi') || false;
};
